var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isListContent)?_c('Card',{class:_vm.$style.root,attrs:{"padding":"blue","radius-side":"all"}},[(_vm.isListContent || _vm.isCanShowLogo)?_c('List',{attrs:{"isCanShowLogo":_vm.isCanShowLogo}}):(_vm.isCanShowLogo)?_c('Simple'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }